import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/database";
import "firebase/auth";
import "firebase/storage";
import "firebase/functions";
import 'firebase/messaging';
import 'firebase/performance'

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD45Y2I9UOHDVJc2BZqpWxQUWfZHNXzETA",
  authDomain: "beauty-caricode.firebaseapp.com",
  databaseURL: "https://beauty-caricode.firebaseio.com",
  projectId: "beauty-caricode",
  storageBucket: "beauty-caricode.appspot.com",
  messagingSenderId: "60915459155",
  appId: "1:60915459155:web:5899909e56a0474f7552a6"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.firestore();
firebase.functions();
firebase.messaging();
firebase.performance();
firebase.firestore().enablePersistence();

export default firebase;
